import {
  Anchor,
  Button,
  Card,
  Center,
  Divider,
  Stack,
  ThemeIcon,
  Title,
  Image,
  TypographyStylesProvider,
  Code,
  Box,
} from "@mantine/core";
import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import DocsButton from "../articlesHelpers/DocsButton"; // Import the new component
import {
  IconArrowBigDownFilled,
  IconArrowBigUpFilled,
  IconCircleMinus,
  IconClock,
  IconExchange,
  IconHistory,
  IconInfoCircle,
} from "@tabler/icons-react";
import { JsonView, allExpanded, darkStyles } from "react-json-view-lite";
import SimpleImage from "../articlesHelpers/SimpleImage";

export const NODE_INFO_AND_ALIAS_CONTENT = (
  <TypographyStylesProvider>
    <p>
      {" "}
      This button gets you to some data that might seem intimidating at first,
      but really isn't that complicated:
    </p>
    <DocsButton
      ariaLabel="node info"
      text="Node Info"
      leftSection={<IconInfoCircle />}
    />
    After you click that button, you'll see something like this:
    <SimpleImage h={600} src="docs_images/node-info2.png" />
    <p>
      Starting from the top, we first have the <strong>Node Public Key</strong>.
      You might see this referred to elsewhere as the "node id". This is a
      unique identifier for your node. No other node will ever have the same{" "}
      <strong>Node Public Key</strong>, and your node public key for this node
      will never change.
    </p>
    <p>
      You might not actually ever need to use your public key, except if you
      want to receive "keysend" payments, but actually keysend payments{" "}
      <a href="/docs/sending-payments#keysend-payments" target="_blank">
        can be a bit problematic
      </a>
      .
    </p>
    <p>
      Next you have your <strong>Node URI</strong>, which is even longer and
      more complicated-looking than your public key. If you stare at it for long
      enough, however, you'll see the first part -- the part before the "@" --
      is actually just <strong>Node Public Key</strong>. Everything after the
      "@" is a TOR address. (TOR is a a privacy-focused way of hooking up your
      node to the Internet).
    </p>
    <p>
      {" "}
      But when would you actually use your <strong>Node URI</strong>?. Mostly
      just when you want OTHER nodes to CONNECT TO YOU. If someone says, "hey, I
      want to open a channel to your node", then you need to give them your{" "}
      <strong>Node URI</strong>.{" "}
    </p>
    <p>
      {" "}
      Skipping to the bottom, you can see the <strong>Nostr Public Key</strong>.
      This also won't change, and it uniquely identifies your node on Nostr. You
      might want to use it to log into Nostr services, or things like that.{" "}
    </p>
    <Title order={4}>Node Alias</Title>
    <p>
      Finally, let's discuss your <strong>Node Alias</strong>. Changing your
      alias is pretty straightforward, but keep these points in mind:
    </p>
    <ol>
      <li>Node aliases are not guaranteed to be unique.</li>
      <li>Any node can change their own alias at any time.</li>
      <li>
        Your alias is completely public and will be viewable on Lightning
        explorers... if your node becomes famous, that means your alias will
        rank on search engines like Google, too... So be careful what text you
        put in your alias.
      </li>
      <li>
        When you change your alias, there might be a wait up to TWO OR THREE
        DAYS before every part of the network has updated to your new alias.
      </li>
    </ol>
    <SimpleImage h={300} src="docs_images/node-alias.png" />
  </TypographyStylesProvider>
);
